export const APP_NAME = 'Attendee Registration Processing';
export const DEFAULT_PAGE_SIZE = 10;
export const DATE_FORMAT = 'MMM dd, yyyy';
